<template>
  <div class="event-list-manager">
    <div>
      <ul>
        <li :class="{mobile: mobile}">
          <h4>{{ event.event }}</h4>
          <p>{{ event.highlights }}</p>
          <div class="icontain">
            <TrashIcon
              class="icon"
              @click="deleteEvent"
            />
          </div>
        </li>
      </ul>
    </div>
    <teleport to="#modals">
      <modal v-if="toggleModal">Deleting...</modal>
    </teleport>
  </div>
</template>

<script>
import { reactive, toRefs } from '@vue/reactivity'
import Modal from '@/components/Modal'
import { onMounted } from '@vue/runtime-core'
import { TrashIcon } from '@heroicons/vue/outline'
import { db, deleteDoc, doc, ref, deleteObject, storage } from '@/firebase/config'

export default {
  components: { TrashIcon, Modal },
  props: ['event'],
  emit: ['deletion'],
  setup (props, context) {
    const responsive = reactive({
      mobile: false,
      windowWidth: null,
      toggleModal: false,
      toast: false
    })
    const { mobile, windowWidth, toggleModal, toast } = toRefs(responsive)

    // Create a reference to the file to delete
    const storedRef = ref(storage, `/schools/inspire-schools/events/${props.event.name}`)
    // deleteRecord
    const deleteEvent = async () => {
      toggleModal.value = true
      await deleteObject(storedRef)
      await deleteDoc(doc(db, '/schools/inspire-schools/events', props.event.id))
      toggleModal.value = false
      context.emit('deletion')
    }

    const handleview = () => {
      windowWidth.value = window.innerWidth
      if (windowWidth.value <= 750) {
        mobile.value = true
        return
      }
      mobile.value = false
    }

    onMounted(() => {
      handleview()
      window.addEventListener('resize', handleview)
    })
    return { mobile, deleteEvent, toast, toggleModal }
  }
}
</script>

<style>
.event-list-manager {
  background: #fff;
}
.event-list-manager div {
  background: white;
  border: 1px solid pink;
  padding: 5px;
}
.event-list-manager li {
  list-style-type: none;
  background: #eee;
  padding: 10px 20px;
  margin: 5px auto;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.event-list-manager .icontain {
  background: transparent;
  border: none;
  display: flex;
  justify-content: flex-end;
  width: 100px;
}
.event-list-manager li.mobile .icontain {
  flex-direction: column;
}
.event-list-manager li.mobile .icon {
  margin-top: 10px;
}
.event-list-manager li.mobile {
  display: flex;
  flex-direction: column;
}
.event-list-manager .icon {
  max-width: 17px;
  cursor: pointer;
  margin-left: 25px;
}
.event-list-manager p, h3, ul {
    padding: 0;
    margin: 0;
}
</style>
